module.exports = __webpack_public_path__ + "img/eriam-logo.20271e4c.png";